import { ErrorBoundary } from './ErrorBoundaryReact';
import type { ErrorBoundaryProps } from './ErrorBoundaryReact';
import { ErrorFallbackComponent } from './ErrorFallbackComponent';

type ErrorBoundaryForPagesProps = Omit<ErrorBoundaryProps, 'fallbackComponent'>;

/**
 * You can use this Error Boundary to catch errors in pages.
 * If you need an error boundary for a component, please use ErrorBoundaryForComponents.
 */
export const ErrorBoundaryForPages = (props: ErrorBoundaryForPagesProps): JSX.Element => {
  return <ErrorBoundary {...props} fallbackComponent={ErrorFallbackComponent} />;
};
